<app-navigation tagline="WEITERES" marginLeftClass="ml-10"></app-navigation>
<ion-content style="background-color: #fff">
  <div class="ion-margin slide">
    <div class="ion-padding">
      <p>Wenn Du mehr über Deine Interessen herausfinden willst, hier geht’s weiter:
        <a target="_blank" href="https://www.was-studiere-ich.de/">https://www.was-studiere-ich.de/</a>.</p>
        <p>
        Im Orientierungstest werden übrigens beide Richtungen getestet: Studium und Ausbildung.</p>

      <p>
        Wenn Du weitere Informationen brauchst, empfehlen wir Dir unsere „Nützlichen Links“.
      </p>
      <ion-toolbar color="transparent" >
        <ion-buttons slot="start">
          <ion-back-button text="" class="bbutton" defaultHref="/questionnaire/result" slot="start" icon="assets/img/arrowLast.svg">
          </ion-back-button>
        </ion-buttons>
    </ion-toolbar>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
